"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var Schema = (_a = {},
    _a[constants_1.CMDS.GET_BASIC_INFO] = [],
    _a[constants_1.CMDS.GET_TX_LIST] = [],
    _a[constants_1.CMDS.GET_DEPOSIT_ADDRESS] = ['currency'],
    _a[constants_1.CMDS.GET_CALLBACK_ADDRESS] = ['currency'],
    _a[constants_1.CMDS.CREATE_TRANSFER] = ['amount', 'currency', ['merchant', 'pbntag']],
    _a[constants_1.CMDS.CONVERT] = ['amount', 'from', 'to'],
    _a[constants_1.CMDS.CONVERT_LIMITS] = ['from', 'to'],
    _a[constants_1.CMDS.GET_WITHDRAWAL_HISTORY] = [],
    _a[constants_1.CMDS.GET_CONVERSATION_INFO] = ['id'],
    _a[constants_1.CMDS.GET_TAG_INFO] = ['pbntag'],
    _a[constants_1.CMDS.GET_TAG_LIST] = [],
    _a[constants_1.CMDS.UPDATE_TAG] = ['tagid'],
    _a[constants_1.CMDS.CLAIM_TAG] = ['tagid', 'name'],
    _a[constants_1.CMDS.GET_WITHDRAWAL_INFO] = ['id'],
    _a[constants_1.CMDS.GET_TX] = ['txid'],
    _a[constants_1.CMDS.GET_TX_MULTI] = ['txid'],
    _a[constants_1.CMDS.CREATE_WITHDRAWAL] = ['amount', 'currency', ['address', 'pbntag']],
    _a[constants_1.CMDS.CREATE_MASS_WITHDRAWAL] = [],
    _a[constants_1.CMDS.CREATE_TRANSACTION] = [
        'amount',
        'currency1',
        'currency2',
        'buyer_email',
    ],
    _a[constants_1.CMDS.RATES] = [],
    _a[constants_1.CMDS.BALANCES] = [],
    _a[constants_1.CMDS.RENEW_TAG] = ['tagid', 'coin'],
    _a[constants_1.CMDS.DELETE_TAG] = ['tagid'],
    _a[constants_1.CMDS.CLAIM_COUPON] = ['coupon'],
    _a[constants_1.CMDS.BUY_TAG] = ['coin'],
    _a);
exports.default = Schema;
